import React from "react";
import { Row, Col, Card, Form, Input, Divider, Space, Image } from "antd";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
const { TextArea } = Input;

const Layout3 = ({ onChange, initialData }) => {
  const [form] = Form.useForm();
  const imageUrl = Form.useWatch("imageUrl", form);

  return (
    <Card
      style={{
        background: "#f9fafb",
        border: "2px dashed #1890ff",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialData}
        onValuesChange={(_, allValues) => onChange(allValues)}
      >
        <Row gutter={32}>
          <Col span={10}>
            <Form.Item label="Image URL" name="imageUrl">
              <Input placeholder="Paste image URL" />
            </Form.Item>
            <div
              style={{
                width: "100%",
                border: "1px dashed #d9d9d9",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff",
              }}
            >
              {imageUrl ? (
                <Image
                  src={imageUrl}
                  alt="Preview"
                  style={{
                    objectFit: "cover",
                  }}
                />
              ) : (
                <span style={{ color: "#999" }}>Image Preview</span>
              )}
            </div>
          </Col>
          <Col span={14}>
            {/* Small Title */}
            <Form.Item label="Small Title" name="smallTitle">
              <Input placeholder="About Us" />
            </Form.Item>
            {/* Main Title */}
            <Form.Item label="Main Title" name="mainTitle">
              <Input placeholder="We are crafting your unique business consulting ideas." />
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input placeholder="We are crafting your unique business consulting ideas and  business consulting ideas" />
            </Form.Item>
            {/* Dynamic 2-column card layout */}
            <Form.List name="cards" initialValue={[{}, {}]}>
              {(fields, { add, remove }) => (
                <>
                  <Row gutter={[24, 24]}>
                    {fields.map((field, index) => (
                      <Col span={12} key={field.key}>
                        <Card
                          bordered={false}
                          style={{
                            background: "#fff",
                            borderRadius: 12,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                            height: "100%",
                          }}
                        >
                          {/* Image URL */}
                          <Form.Item
                            label="Icon / Image URL"
                            name={[field.name, "image"]}
                          >
                            <Input placeholder="Paste icon or image URL" />
                          </Form.Item>
                          {/* Title */}
                          <Form.Item
                            label="Title"
                            name={[field.name, "title"]}
                          >
                            <Input placeholder="Finance Consultant" />
                          </Form.Item>
                          {/* Description */}
                          <Form.Item
                            label="Description"
                            name={[field.name, "description"]}
                          >
                            <TextArea
                              rows={2}
                              placeholder="Sed ut perspiciatis unde omnis iste natus error sit."
                            />
                          </Form.Item>
                          {/* Actions */}
                          <Space>
                            {index === fields.length - 1 && (
                              <PlusCircleOutlined
                                style={{ fontSize: 18, color: "#1890ff" }}
                                onClick={() => add()}
                              />
                            )}
                            {fields.length > 1 && (
                              <DeleteOutlined
                                style={{ fontSize: 18, color: "red" }}
                                onClick={() => remove(field.name)}
                              />
                            )}
                          </Space>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default Layout3;